import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useSavingsStore } from '@/store/useSavingsStore'

export const FirstDepositAmountDisplay: React.FC = () => {
  const isFiatMode = useSavingsStore((state) => state.goalTransferIn.isFiatMode)
  const fiatAmount = useSavingsStore((state) => state.goalTransferIn.fiatAmount)
  const cryptoAmount = useSavingsStore(
    (state) => state.goalTransferIn.cryptoAmount,
  )
  const triggerShake = useSavingsStore(
    (state) => state.goalTransferIn.triggerShake,
  )

  const adaptedAmount = isFiatMode ? fiatAmount : cryptoAmount
  const displayAmount = adaptedAmount.amount || '0'

  // Вычисляем размер шрифта в зависимости от длины текста (как в WithdrawAmountDisplay)
  const getFontSizeForAmount = (text: string) => {
    const length = text.length
    if (length <= 8) return 64
    if (length <= 12) return 48
    if (length <= 16) return 36
    return 24
  }

  return (
    <BaseView
      center
      style={{
        height: 74,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className={triggerShake ? 'animate-shake' : ''}
    >
      <BaseText
        fontFamily="bold"
        color="label.default"
        style={{
          fontSize: getFontSizeForAmount(displayAmount),
          lineHeight: 1,
          letterSpacing: '-0.02em',
          maxWidth: '100%',
          textAlign: 'center',
          transition: 'font-size 0.2s ease',
        }}
      >
        {displayAmount}
      </BaseText>

      {/* Отображаем код валюты рядом с суммой */}
      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.secondary"
        style={{
          marginTop: 4,
          textAlign: 'center',
        }}
      >
        {adaptedAmount.code}
      </BaseText>
    </BaseView>
  )
}
